import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';

// Shown instead of the billing form when the billing GET failed and there is no cached row, so a
// one-off failure is not mistaken for "this account has no billing information yet".
export const BillingLoadError = ({ onRetry }: { onRetry: () => void }) => (
  <Alert
    id="billing-load-error"
    severity="error"
    sx={{ mt: 2 }}
    action={(
      <Button id="billing-load-retry-btn" color="inherit" size="small" onClick={onRetry}>
        <FormattedMessage id="page.payment.billing.load.retry" />
      </Button>
    )}
  >
    <FormattedMessage id="page.payment.billing.load.error" />
  </Alert>
);
